module.exports = __webpack_public_path__ + "img/Popup_Anzahl.9d18fdf1.png";